import { SVG, Text } from "sunrise-ui";
import { Grid } from "@material-ui/core";

const NoDataScreen = (props: any) => (
  <Grid container className="nodata">
    <Grid item xs={12} md={3}></Grid>
    <Grid item xs={12} md={6} className="nodata">
      <Grid>
        <SVG type="noDataBig" />
      </Grid>
      <Text type="normal" fonts="normal" className="mt0 mb0">
        {props.text}
      </Text>
    </Grid>
    <Grid item xs={12} md={3}></Grid>
  </Grid>
);

export default NoDataScreen;
